import {
  getDateHeaderByType,
  getRecurringHeaderByStatus,
} from 'components/orders/SectionHeaders/components';

export default {
  getDateHeaderByType,
  getRecurringHeaderByStatus,
};
